<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="11">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-jiaoseliebiao el-icon--left"></i>角色
          </div>
          <div class="es-op-box">
            <el-input placeholder="请输入角色名称"
                      v-model="queryObj.keyWord"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="
                () => {
                  this.queryObj.pageNum = 1;
                  init();
                }
              ">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right: 6px"
                       @click="add_init">新增</el-button>
            <!-- <es-delete @del="del()"
                       type="button"></es-delete> -->
          </div>
          <el-table :data="pageData.list"
                    ref="roleTable"
                    border
                    size="mini"
                    highlight-current-row
                    @current-change="handleCurrentChange"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="index"
                             label="序号"
                             width="80"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="角色名称"> </el-table-column>
            <el-table-column label="操作"
                             width="120"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="del(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="
                (cpage) => {
                  this.queryObj.pageNum = cpage;
                  this.loadRoleList();
                }
              ">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
      <el-col :span="7">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-gongneng el-icon--left"></i>功能【{{ currentRow.name }}】
            <div class="es-op-box"
                 style="float: right; width: 50px">
              <el-button type="primary"
                         size="mini"
                         @click="saveFuncList()"
                         style="margin-top: -4px"
                         :loading="savingFun">保 存</el-button>
            </div>
          </div>
          <el-table :data="funcDataList"
                    ref="funcTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 180px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="funcName"
                             label="功能名称">
            </el-table-column>
            <el-table-column prop="code"
                             label="功能编码"> </el-table-column>
          </el-table>
        </el-card>
      </el-col>
      <el-col :span="6">
        <el-card class="card">
          <div slot="header"
               class="card-header">
            <i class="el-icon-font el-icon-caidan el-icon--left"></i>菜单【{{ currentRow.name }}】
            <div class="es-op-box"
                 style="float: right; width: 50px">
              <el-button type="primary"
                         size="mini"
                         @click="saveTreeMenu()"
                         style="margin-top: -4px"
                         :loading="savingMenu">保 存</el-button>
            </div>
          </div>
          <div style="overflow: auto; height: calc(100vh - 179px)">
            <el-tree :data="menuTreeOptions"
                     show-checkbox
                     :check-strictly="true"
                     @check="menuCheckChange"
                     default-expand-all
                     node-key="id"
                     ref="menuTree"
                     highlight-current
                     class="org_tree_class"
                     :props="defaultProps">
            </el-tree>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <!--编辑角色信息-->
    <el-dialog :visible.sync="editVisible"
               @closed="() => this.$refs['roleForm'].clearValidate()"
               width="500px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>{{ titleName }}
      </span>
      <el-form :model="roleInfo"
               :rules="rules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="roleForm">
        <el-form-item prop="name"
                      label="角色名称">
          <el-input v-model="roleInfo.name"
                    placeholder="请输入角色名称"
                    style="width: 200px"
                    clearable>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitRole()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "role",
  props: ["funcs"],
  data () {
    return {
      currentRow: {},
      roleMenuList: [],
      roleFuncList: [],
      titleName: "添加角色",
      defaultProps: {
        children: "children",
        label: "label",
      },
      menuTreeOptions: [],
      funcDataList: [],
      roleMenus: [],
      roleFuncs: [],
      queryObj: { pageNum: 1, pageSize: 20 }, //查询条件
      pageData: {},
      editVisible: false,
      roleInfo: {}, //系统信息
      rules: {
        //验证条件
        name: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
          { max: 20, message: "不能超过20个字符", trigger: "blur" },
        ],
      },
      loading: false,
      saving: false,
      savingMenu: false,
      savingFun: false,
    };
  },
  methods: {
    //页面初始化
    init () {
      this.loadRoleList();
    },
    // 获取功能菜单树
    getMenuAndFunclist () {
      this.$ajax
        .get("/base/role/getMenuAndFunclist")
        .then((msg) => {
          console.log("getMenuAndFunclist", msg);
          this.menuTreeOptions = msg.menus;
          this.funcDataList = msg.funcs;
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    //从后台查询角色列表
    loadRoleList () {
      this.loading = true;
      this.$ajax
        .get("/base/role/list", this.queryObj)
        .then((msg) => {
          this.pageData = msg;
          console.log("pageData", msg);
          if (msg.list.length > 0) {
            this.setCurrent(msg.list[0]);
          }
          this.loading = false;
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    //初始化添加角色
    add_init () {
      this.editVisible = true;
      this.roleInfo = {};
      this.titleName = "添加角色";
    },
    //初始化角色
    edit_init (row) {
      this.editVisible = true;
      this.roleInfo = JSON.parse(JSON.stringify(row));
      this.titleName = "編輯角色";
    },
    handleCurrentChange (val) {
      console.log("handleCurrentChange");
      this.currentRow = val;
      this.$nextTick(function () {
        this.$refs.funcTable.clearSelection();
      });
      this.getMenuAndFuncByRoleId(val);
    },
    getMenuAndFuncByRoleId (val) {
      let id = val.id
      if (id != null) {
        this.loading = true;
        this.$ajax
          .get("/base/role/getMenuAndFuncByRoleId", { id: id })
          .then((msg) => {
            console.log(msg);
            this.roleMenus = msg.menus;
            this.roleFuncs = msg.funcs;
            this.setCheckedKeys(this.roleMenus);
            this.toggleSelection(this.roleFuncs);
            this.loading = false;
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    setCheckedKeys (menus) {
      console.log("setCheckedKeys");
      this.$nextTick(function () {
        this.$refs.menuTree.setCheckedKeys(menus);
      });
    },
    setCurrent (row) {
      console.log("setCurrent");
      this.currentRow = row;
      // this.getMenuAndFuncByRoleId(row);
      this.$nextTick(function () {
        this.$refs.roleTable.setCurrentRow(row);
      });
    },
    //保存角色
    submitRole () {
      this.$refs["roleForm"].validate((valid) => {
        if (valid) {
          let url = "/base/role/add";
          if (this.roleInfo.id != null) {
            url = "/base/role/edit";
          }
          this.saving = true;
          this.$ajax
            .post(url, this.roleInfo)
            .then((msg) => {
              this.saving = false;
              this.loadRoleList();
              this.editVisible = false;
              this.$message.success(msg);
            })
            .catch((err) => {
              this.$message.error(err);
              this.saving = false;
            });
        }
      });
    },
    //删除角色
    del (delId) {
      let ids = [];
      if (delId != null) {
        ids = [delId];
      } else {
        this.$refs["roleTable"].selection.forEach((ele) => {
          ids.push(ele.id);
        });
      }
      if (ids.length > 0) {
        this.loading = true;
        this.$ajax
          .post("/base/role/delete", { ids: ids })
          .then((msg) => {
            this.loading = false;
            this.$message.success(msg);
            this.queryObj.pageNum = 1; //删除之后，回到第一页
            this.loadRoleList();
          })
          .catch((err) => {
            this.$message.error(err);
            this.loading = false;
          });
      }
    },
    menuCheckChange (data) {
      let thisNode = this.$refs.menuTree.getNode(data.id); // 获取当前节点
      const keys = this.$refs.menuTree.getCheckedKeys(); // 获取已勾选节点的key值
      console.log(keys);
      if (thisNode.checked) {
        // 当前节点若被选中
        for (let i = thisNode.level; i > 1; i--) {
          // 判断是否有父级节点
          if (!thisNode.parent.checked) {
            // 父级节点未被选中，则将父节点替换成当前节点，往上继续查询，并将此节点key存入keys数组
            thisNode = thisNode.parent;
            keys.push(thisNode.data.id);
          }
        }
      }
      this.$refs.menuTree.setCheckedKeys(keys); // 将所有keys数组的节点全选中
    },
    saveTreeMenu () {
      const keys = this.$refs.menuTree.getCheckedKeys();
      for (let i = 0; i < keys.length; i++) {
        var param = new Object();
        param.roleId = this.currentRow.id;
        param.menuId = keys[i];
        this.roleMenuList.push(param);
      }
      if (this.roleMenuList && this.roleMenuList.length > 0) {
        let url = "/base/role/addMenu";
        this.savingMenu = true;
        this.$ajax
          .post(url, this.roleMenuList)
          .then((msg) => {
            this.savingMenu = false;
            this.roleMenuList = [];
            this.$message.success(msg);
          })
          .catch((err) => {
            this.$message.error(err);
            this.savingMenu = false;
            this.roleMenuList = [];
          });
      } else {
        this.$message.error("请选择菜单权限！");
      }
    },
    saveFuncList () {
      this.$refs["funcTable"].selection.forEach((ele) => {
        this.roleFuncs.push(ele.code);
        var param = new Object();
        param.roleId = this.currentRow.id;
        param.funcCode = ele.code;
        this.roleFuncList.push(param);
      });
      if (this.roleFuncList && this.roleFuncList.length > 0) {
        let url = "/base/role/addFunc";
        this.savingFun = true;
        this.$ajax
          .post(url, this.roleFuncList)
          .then((msg) => {
            this.savingFun = false;
            this.roleFuncList = [];
            this.$message.success(msg);
          })
          .catch((err) => {
            this.$message.error(err);
            this.savingFun = false;
            this.roleFuncList = [];
          });
      } else {
        this.$message.error("请选择功能权限！");
      }
    },
    toggleSelection (roleFuncs) {
      console.log("toggleSelection", roleFuncs);
      roleFuncs.forEach((item) => {
        // checkedData为已选数据
        this.$nextTick(() => {
          this.funcDataList.find((obj) => {
            // userData 表单数据
            if (item === obj.code) {
              this.$refs.funcTable.toggleRowSelection(obj, true);
            }
          });
        });
      });


      // var rows = new Array();
      // for (let i = 0; i < roleFuncs.length; i++) {
      //   rows.push(this.funcDataList.find((item) => item.code === roleFuncs[i]));
      // }
      // console.log("roleFuncs", roleFuncs);
      // console.log("rows", rows);
      // this.$nextTick(function () {
      //   if (rows && rows.length > 0) {
      //     rows.forEach((row) => {
      //       this.$refs.funcTable.toggleRowSelection(row);
      //     });
      //   } else {
      //     this.$refs.funcTable.clearSelection();
      //   }
      // });
    },
  },
  created () {
    this.getMenuAndFunclist();
  },
  mounted () {
    this.init();
  },
};
</script>
<style scoped>
.org_tree_class {
  min-width: 210px;
}
</style>